<!-- footer start-->
<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 footer-copyright text-center">
      <p class="mb-0">Copyright {{ today | date:'y' }}
        | © INDESOFT A&A SAS 
        | Versión {{ version }} </p>
    </div>
  </div>
</div>